export const sortBookingsHelper = (bookingsList: any[]) => {
    return bookingsList.sort((a, b) => {
        const dateComparison = new Date(b.date).getTime() - new Date(a.date).getTime();
        if (dateComparison !== 0) return dateComparison;
        return b.time.localeCompare(a.time);
    });
};
